"use strict"; // Returns "Type(value) is Object" in ES terminology.

var _slicedToArray = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function isObject(value) {
  return typeof value === "object" && value !== null || typeof value === "function";
}

var hasOwn = Function.prototype.call.bind(Object.prototype.hasOwnProperty);
var wrapperSymbol = Symbol("wrapper");
var implSymbol = Symbol("impl");
var sameObjectCaches = Symbol("SameObject caches");
var ctorRegistrySymbol = Symbol.for("[webidl2js]  constructor registry");

function getSameObject(wrapper, prop, creator) {
  if (!wrapper[sameObjectCaches]) {
    wrapper[sameObjectCaches] = Object.create(null);
  }

  if (prop in wrapper[sameObjectCaches]) {
    return wrapper[sameObjectCaches][prop];
  }

  wrapper[sameObjectCaches][prop] = creator();
  return wrapper[sameObjectCaches][prop];
}

function wrapperForImpl(impl) {
  return impl ? impl[wrapperSymbol] : null;
}

function implForWrapper(wrapper) {
  return wrapper ? wrapper[implSymbol] : null;
}

function tryWrapperForImpl(impl) {
  var wrapper = wrapperForImpl(impl);
  return wrapper ? wrapper : impl;
}

function tryImplForWrapper(wrapper) {
  var impl = implForWrapper(wrapper);
  return impl ? impl : wrapper;
}

var iterInternalSymbol = Symbol("internal");
var IteratorPrototype = Object.getPrototypeOf(Object.getPrototypeOf([][Symbol.iterator]()));
var AsyncIteratorPrototype = Object.getPrototypeOf(Object.getPrototypeOf(
/*#__PURE__*/
_wrapAsyncGenerator(
/*#__PURE__*/
_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}))).prototype);

function isArrayIndexPropName(P) {
  if (typeof P !== "string") {
    return false;
  }

  var i = P >>> 0;

  if (i === Math.pow(2, 32) - 1) {
    return false;
  }

  var s = "".concat(i);

  if (P !== s) {
    return false;
  }

  return true;
}

var byteLengthGetter = Object.getOwnPropertyDescriptor(ArrayBuffer.prototype, "byteLength").get;

function isArrayBuffer(value) {
  try {
    byteLengthGetter.call(value);
    return true;
  } catch (e) {
    return false;
  }
}

function iteratorResult(_ref2, kind) {
  var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];

  var result;

  switch (kind) {
    case "key":
      result = key;
      break;

    case "value":
      result = value;
      break;

    case "key+value":
      result = [key, value];
      break;
  }

  return {
    value: result,
    done: false
  };
}

var supportsPropertyIndex = Symbol("supports property index");
var supportedPropertyIndices = Symbol("supported property indices");
var supportsPropertyName = Symbol("supports property name");
var supportedPropertyNames = Symbol("supported property names");
var indexedGet = Symbol("indexed property get");
var indexedSetNew = Symbol("indexed property set new");
var indexedSetExisting = Symbol("indexed property set existing");
var namedGet = Symbol("named property get");
var namedSetNew = Symbol("named property set new");
var namedSetExisting = Symbol("named property set existing");
var namedDelete = Symbol("named property delete");
var asyncIteratorNext = Symbol("async iterator get the next iteration result");
var asyncIteratorReturn = Symbol("async iterator return steps");
var asyncIteratorInit = Symbol("async iterator initialization steps");
var asyncIteratorEOI = Symbol("async iterator end of iteration");
module.exports = exports = {
  isObject: isObject,
  hasOwn: hasOwn,
  wrapperSymbol: wrapperSymbol,
  implSymbol: implSymbol,
  getSameObject: getSameObject,
  ctorRegistrySymbol: ctorRegistrySymbol,
  wrapperForImpl: wrapperForImpl,
  implForWrapper: implForWrapper,
  tryWrapperForImpl: tryWrapperForImpl,
  tryImplForWrapper: tryImplForWrapper,
  iterInternalSymbol: iterInternalSymbol,
  IteratorPrototype: IteratorPrototype,
  AsyncIteratorPrototype: AsyncIteratorPrototype,
  isArrayBuffer: isArrayBuffer,
  isArrayIndexPropName: isArrayIndexPropName,
  supportsPropertyIndex: supportsPropertyIndex,
  supportedPropertyIndices: supportedPropertyIndices,
  supportsPropertyName: supportsPropertyName,
  supportedPropertyNames: supportedPropertyNames,
  indexedGet: indexedGet,
  indexedSetNew: indexedSetNew,
  indexedSetExisting: indexedSetExisting,
  namedGet: namedGet,
  namedSetNew: namedSetNew,
  namedSetExisting: namedSetExisting,
  namedDelete: namedDelete,
  asyncIteratorNext: asyncIteratorNext,
  asyncIteratorReturn: asyncIteratorReturn,
  asyncIteratorInit: asyncIteratorInit,
  asyncIteratorEOI: asyncIteratorEOI,
  iteratorResult: iteratorResult
};